/**
 * Landing Popup Module
 *
 * A standalone module for displaying a landing popup with contact form.
 * Can be conditionally loaded on specific pages.
 *
 * Usage:
 * import { initLandingPopup } from './landingPopup.js';
 * window.addEventListener('load', () => initLandingPopup({ delay: 8000 }));
 */ const $7bb113885e6342e7$var$POPUP_KEY = `landing_popup_shown_${window.location.pathname}`;
function $7bb113885e6342e7$var$isMobile() {
    return window.matchMedia("(max-width: 1200px)").matches;
}
// 1. Function to inject the HTML into the page
function $7bb113885e6342e7$var$injectPopupHTML() {
    const html = `
    <div
      id="landingPopup"
      class="hidden fixed inset-0 z-50 items-center justify-center bg-black/60"
    >
      <div class="w-full p-2 lg:max-w-5xl mx-auto">
        <div class="relative bg-white rounded-3xl p-4">
          <!-- Close Button -->
          <button
            id="closePopup"
            class="absolute top-1 -right-10 text-2xl text-white"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="lucide lucide-circle-x-icon lucide-circle-x"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m15 9-6 6" />
              <path d="m9 9 6 6" />
            </svg>
          </button>

          <div class="grid grid-cols-2 gap-4">
            <div class="">
              <div class="">
                <h2
                  class="text-2xl max-w-sm text-headingColor mb-3 font-semibold font-publicSans tracking-wide"
                >
                  Build High Performance Software with Confidence
                </h2>
                <p
                  class="lg:text-sm 2xl:text-base font-normal text-headingLight font-publicSans tracking-wide mb-8"
                >
                  Trusted by startups, enterprises, and global brands building
                  mission-critical digital products.
                </p>

                <div
                  class="rounded-2xl bg-gradient-to-r from-[#E9F8F0] via-[#EEF3FF] to-[#EFE6FF] p-5"
                >
                  <div
                    class="flex flex-col lg:flex-row items-center justify-between gap-3"
                  >
                    <!-- Item 1 -->
                    <div class="flex-1">
                      <h3
                        class="text-xl font lg:text-3.5xl font-semibold text-headingColor"
                      >
                        300+
                      </h3>
                      <p
                        class="text-sm font-normal font-publicSans tracking-wide text-headingColor"
                      >
                        Projects delivered
                      </p>
                    </div>
                    <div
                      class="hidden h-full min-h-[4rem] w-[1.5px] self-stretch border-t-0 gradiantBorderLine lg:block"
                    ></div>

                    <!-- Item 2 -->
                    <div class="flex-1">
                      <h3
                        class="text-xl font lg:text-3.5xl font-semibold text-headingColor"
                      >
                        12+
                      </h3>
                      <p
                        class="text-sm font-normal font-publicSans tracking-wide text-headingColor"
                      >
                        Years of Expertise
                      </p>
                    </div>
                    <div
                      class="hidden h-full min-h-[4rem] w-[1.5px] self-stretch border-t-0 gradiantBorderLine lg:block"
                    ></div>

                    <!-- Item 3 -->
                    <div class="flex-1 pl-3">
                      <h3
                        class="text-xl font lg:text-3.5xl font-semibold text-headingColor"
                      >
                        97%
                      </h3>
                      <p
                        class="text-sm font-normal font-publicSans tracking-wide text-headingColor"
                      >
                        Client Retention
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex justify-center flex-wrap gap-5 mt-8">
                <!-- items for loop -->
                <div
                  class="relative rounded-[1.25rem] p-1 min-h-[6rem] w-[13.25rem] conicGradiantCards"
                >
                  <a href="https://clutch.co/profile/quokka-labs">
                    <div
                      class="card rounded-[20px] 2xl:p-3 p-3 lg:p-2 h-full flex flex-col justify-between"
                    >
                      <div class="flex items-center gap-2 lg:gap-3">
                        <!-- logo placeholder -->
                        <div class="flex-shrink-0">
                          <div
                            class="w-[2rem] h-[2.1875rem] flex items-center justify-center overflow-hidden"
                          >
                            <img
                              src="https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/clutchtransparent.webp"
                              loading="lazy"
                              alt="brand"
                              class="w-full h-full"
                            />
                          </div>
                        </div>

                        <!-- rating and reviews -->
                        <div class="flex-1">
                          <div class="flex items-center gap-2">
                            <div class="text-xl font-bold text-headingColor">
                              5.0
                            </div>
                            <div class="text-xl lg:text-2xl">
                              <!-- star -->
                              <svg
                                class="w-4 h-4 text-red-500"
                                viewBox="0 0 24 24"
                                fill="#6A797E"
                                aria-hidden="true"
                              >
                                <path
                                  d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.786 1.401 8.164L12 18.896l-7.335 3.864 1.401-8.164L.132 9.21l8.2-1.192z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- lower-left award text -->
                      <div class="">
                        <p
                          class="text-[0.625rem] uppercase tracking-wide font-semibold text-headingColor max-w-[80%] 2xl:max-w-[80%] xl:max-w-[80%] lg:max-w-[80%] md:max-w-[90%] font-publicSans"
                        >
                          Top Mobile App Developers
                        </p>
                      </div>
                    </div>
                  </a>
                </div>

                <!-- Card 2 - Blue -->
                <div
                  class="relative rounded-[1.25rem] p-1 min-h-[6rem] w-[13.25rem] conicGradiantCards2"
                >
                  <a href="https://www.goodfirms.co/company/quokka-labs">
                    <div
                      class="card rounded-[20px] 2xl:p-3 p-3 lg:p-2 h-full flex flex-col justify-between"
                    >
                      <div class="flex items-center gap-4 lg:gap-3">
                        <div class="flex-shrink-0">
                          <!-- logo placeholder -->
                          <div class="flex-shrink-0">
                            <div
                              class="w-[34px] h-[30px] flex items-center justify-center overflow-hidden"
                            >
                              <img
                                src="https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Top_ITtransparent.webp"
                                loading="lazy"
                                alt="brand"
                                class="w-full h-full"
                              />
                            </div>
                          </div>
                        </div>

                        <div class="flex-1">
                          <div class="flex items-center gap-2">
                            <div class="text-xl font-bold text-headingColor">
                              5.0
                            </div>
                            <div class="text-xl lg:text-2xl">
                              <svg
                                class="w-4 h-4 text-sky-500"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.786 1.401 8.164L12 18.896l-7.335 3.864 1.401-8.164L.132 9.21l8.2-1.192z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="">
                        <p
                          class="text-[10px] uppercase tracking-wide font-semibold text-headingColor max-w-[80%] 2xl:max-w-[80%] xl:max-w-[80%] lg:max-w-[80%] md:max-w-[90%] font-publicSans"
                        >
                          Top Mobile App Development Company
                        </p>
                      </div>
                    </div>
                  </a>
                </div>

                <!-- items for loop -->
                <div
                  class="relative rounded-[1.25rem] p-1 min-h-[6rem] w-[13.25rem] conicGradiantCards3"
                >
                  <a
                    href="https://www.designrush.com/agency/profile/quokka-labs"
                  >
                    <div
                      class="card rounded-[20px] 2xl:p-3 p-3 lg:p-2 h-full flex flex-col justify-between"
                    >
                      <div class="flex items-center gap-2 lg:gap-3">
                        <!-- logo placeholder -->
                        <div class="flex-shrink-0">
                          <div
                            class="w-[2rem] h-[2rem] flex items-center justify-center overflow-hidden"
                          >
                            <img
                              src="https://ql-web-images.s3.us-east-2.amazonaws.com/ql-images/Awards-1.svg"
                              loading="lazy"
                              alt="brand"
                              class="w-full h-full"
                            />
                          </div>
                        </div>

                        <!-- rating and reviews -->
                        <div class="flex-1">
                          <div class="flex items-center gap-2">
                            <div class="text-xl font-bold text-headingColor">
                              5.0
                            </div>
                            <div class="text-xl lg:text-2xl">
                              <!-- star -->
                              <svg
                                class="w-4 h-4 text-red-500"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                aria-hidden="true"
                              >
                                <path
                                  d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.786 1.401 8.164L12 18.896l-7.335 3.864 1.401-8.164L.132 9.21l8.2-1.192z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- lower-left award text -->
                      <div class="">
                        <p
                          class="text-[0.625rem] uppercase tracking-wide font-semibold text-headingColor max-w-[80%] 2xl:max-w-[80%] xl:max-w-[80%] lg:max-w-[80%] md:max-w-[90%] font-publicSans"
                        >
                          Top Mobile App Development Companies
                        </p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- Contact Form Wrapper -->
            <div class="bg-mainPurple h-full radiusBorderBox">
              <div
                class="order-2 lg:order-1 lg:col-span-2 max-w-2xl mx-auto text-white rounded-xl p-6"
              >
                <!-- Header -->
                <div class="text-center">
                  <h2 class="text-lg font-semibold font-publicSans">
                    Tell Us About Your Project
                  </h2>
                  <p class="text-white font-normal text-base mb-4">
                    Share your project idea with us!
                  </p>
                </div>

                <form class="space-y-4" onsubmit="FormSubmitPopup(event)">
                  <div
                    class="flex items-center gap-6 justify-between lg:flex-row flex-col"
                  >
                    <div class="w-full">
                      <label
                        for="fullNamePopup"
                        class="block text-sm font-normal text-white mb-1"
                        >Full Name<span class="text-white">*</span></label
                      >
                      <input
                        type="text"
                        id="fullNamePopup"
                        name="fullNamePopup"
                        required
                        placeholder="Full Name"
                        class="w-full border-[1.2px] rounded-lg min-h-[2.5rem] px-4 py-2 focus:ring-2 focus:none focus:outline-none outline-none"
                      />
                    </div>
                    <div class="w-full">
                      <label
                        class="font-normal block capitalize text-sm mb-1 text-offWhite"
                        for="phonePopup"
                        >Phone Number<span class="text-white">*</span>
                      </label>
                      <div class="grid grid-cols-3">
                        <select
                          id="countryCodePopup"
                          name="countryCodePopup"
                          class="col-span-1 bg-transparent border rounded-lg min-h-[2.5rem] max-w-[74px] border-r-0 rounded-tr-none rounded-br-none focus:outline-none px-2 py-2 lg:h-auto contact-code"
                          required
                        >
                        </select>
                        <input
                          class="col-span-2 border bg-transparent text-sm font-publicSans tracking-wide border-white 0 border-l-0 rounded-tl-none rounded-bl-none h-10 rounded px-3 py-2 outline-none text-white"
                          id="Phone_numberPopup"
                          type="number"
                          inputmode="numeric"
                          placeholder="(555) 000-0000"
                          required
                          name="Phone_numberPopup"
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    class="flex items-center gap-6 justify-between lg:flex-row flex-col"
                  >
                    <div class="w-full">
                      <label
                        class="font-normal block capitalize text-sm mb-1 text-offWhite"
                        for="emailPopup"
                        >Work Email*</label
                      >
                      <input
                        class="w-full border-[1.2px] rounded-lg min-h-[2.5rem] px-4 py-2 focus:ring-2 outline-none focus-none"
                        id="emailPopup"
                        name="emailPopup"
                        placeholder="you@company.com"
                        required
                      />
                    </div>
                  </div>

                  <div class="flex flex-wrap -mx-3">
                    <div class="w-full px-3">
                      <label
                        class="font-normal block capitalize text-sm mb-1 text-offWhite"
                        for="project"
                        >Message (optional)
                      </label>
                      <textarea
                        class="no-resize appearance-none w-full border-[1.2px] rounded-lg px-4 py-2 focus:ring-2 outline-none focus-none h-20 resize-none"
                        id="projectPopup"
                        name="projectPopup"
                        minlength="0"
                        maxlength="1000"
                      ></textarea>
                    </div>
                  </div>

                  <!-- Button -->
                  <div class="flex flex-col gap-4">
                    <div class="flex justify-between items-center">
                      <div class="flex gap-[.25rem] mr-[.75rem]">
                        <div id="captchaImagePopup" class="bg-white/5 py-1 rounded"></div>
                        <button
                          class="d-block w-[1.875rem] lg:w-auto"
                          type="button"
                          onclick="createCaptchaImagePopup()"
                        >
                          <img
                            loading="lazy"
                            src="https://cdn.quokkalabs.com/ql-images/refresh.webp"
                            alt="captcha"
                            class="invert relative"
                          />
                        </button>
                      </div>

                      <input
                        type="text"
                        id="captchaInputPopup"
                        placeholder="Enter the code"
                        class="appearance-none block w-1/2 font-publicSans text-white placeholder-white border py-3 px-4 min-h-[2.5rem] leading-tight border-offWhite focus:outline-none focus:border-gray-100 rounded-lg"
                      />
                      <!-- Honeypot \u{2014} hidden from real users, bots fill it automatically -->
                      <input
                        type="text"
                        name="website"
                        id="honeypotPopup"
                        style="display: none; position: absolute; left: -9999px"
                        tabindex="-1"
                        autocomplete="off"
                      />
                    </div>

                    <div class="w-full text-right">
                      <button
                        type="submit"
                        id="form-buttonPopup"
                        class="bg-white justify-center flex gap-2 items-center w-full h-[3rem] text-mainPurple text-body-large px-14 py-3 lg:py-4 rounded-xl font-normal hover:bg-offPurple"
                        onclick="
                          gtag('send', 'event', {
                            eventCategory: 'Form',
                            eventAction: 'Lead',
                            eventLabel: 'ContactForm',
                          })
                        "
                      >
                        Send Inquiry
                        <svg
                          width="20px"
                          height="20px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="lucide lucide-arrow-right-icon lucide-arrow-right"
                        >
                          <path d="M5 12h14"></path>
                          <path d="m12 5 7 7-7 7"></path>
                        </svg>
                      </button>
                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
    document.body.insertAdjacentHTML("beforeend", html);
}
function $7bb113885e6342e7$var$setupPopup() {
    const popup = document.getElementById("landingPopup");
    const closeBtn = document.getElementById("closePopup");
    const ctaBtn = document.getElementById("popupCTA");
    if (!popup) return;
    // Guard Clauses
    if ($7bb113885e6342e7$var$isMobile()) return;
    if (sessionStorage.getItem($7bb113885e6342e7$var$POPUP_KEY) === "true") return;
    // ✅ Show popup
    popup.classList.remove("hidden");
    popup.classList.add("flex");
    document.body.style.overflow = "hidden";
    function closePopup(e) {
        if (e) e.preventDefault(); // Prevent form jump if it's the CTA
        popup.classList.add("hidden");
        popup.classList.remove("flex");
        document.body.style.overflow = "";
        sessionStorage.setItem($7bb113885e6342e7$var$POPUP_KEY, "true");
    }
    closeBtn?.addEventListener("click", closePopup);
    // Close on submit/CTA click
    ctaBtn?.addEventListener("click", closePopup);
    // Close on backdrop click
    popup.addEventListener("click", (e)=>{
        if (e.target === popup) closePopup();
    });
}
// =============================================
// POPUP FORM — Country Codes
// =============================================
function $7bb113885e6342e7$var$restoreLabelsPopup() {
    const countrySelectPopup = document.getElementById("countryCodePopup");
    if (!countrySelectPopup) return;
    Array.from(countrySelectPopup.options).forEach((option)=>{
        option.textContent = option.dataset.label;
    });
}
function $7bb113885e6342e7$var$collapseToCodePopup() {
    const countrySelectPopup = document.getElementById("countryCodePopup");
    if (!countrySelectPopup) return;
    $7bb113885e6342e7$var$restoreLabelsPopup();
    const selectedOption = countrySelectPopup.options[countrySelectPopup.selectedIndex];
    if (selectedOption) selectedOption.textContent = selectedOption.dataset.code;
}
async function $7bb113885e6342e7$var$loadCountryCodesPopup() {
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/metadata?country_codes=true`);
        const data = await response.json();
        const countrySelectPopup = document.getElementById("countryCodePopup");
        countrySelectPopup.innerHTML = "";
        data.data.country_codes.forEach((country)=>{
            const option = document.createElement("option");
            option.value = country.value;
            option.textContent = country.label;
            option.dataset.code = country.value;
            option.dataset.label = country.label;
            countrySelectPopup.appendChild(option);
        });
        countrySelectPopup.value = "+91";
        $7bb113885e6342e7$var$collapseToCodePopup();
    } catch (error) {
        console.error("Error loading country codes (popup):", error);
    }
}
function $7bb113885e6342e7$var$initCountryCodeDropdown() {
    const countrySelectPopup = document.getElementById("countryCodePopup");
    if (!countrySelectPopup) return;
    countrySelectPopup.addEventListener("mousedown", $7bb113885e6342e7$var$restoreLabelsPopup);
    countrySelectPopup.addEventListener("change", $7bb113885e6342e7$var$collapseToCodePopup);
    $7bb113885e6342e7$var$loadCountryCodesPopup();
}
// =============================================
// POPUP FORM — Captcha
// =============================================
let $7bb113885e6342e7$var$savedCaptchaCodePopup = "";
const $7bb113885e6342e7$var$createCaptchaImagePopup = async ()=>{
    const captchaBox = document.getElementById("captchaImagePopup");
    if (captchaBox) captchaBox.innerHTML = '<div class="w-[9.375rem] h-[3.125rem] border border-white animate-pulse"></div>';
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/captcha`, {
            method: "GET"
        });
        if (!response.ok) throw new Error("Captcha API failed");
        const result = await response.json();
        $7bb113885e6342e7$var$savedCaptchaCodePopup = result.captcha_0 || "";
        if (captchaBox) captchaBox.innerHTML = `
        <img
          src="${result.image_url}"
          alt="captcha"
          class="h-[3.125rem] w-[8.375rem] object-contain rounded"
        />
      `;
    } catch (error) {
        console.error("Captcha Error (popup):", error);
        if (captchaBox) captchaBox.innerHTML = '<div class="text-white text-xs">Captcha failed</div>';
    }
};
window.createCaptchaImagePopup = $7bb113885e6342e7$var$createCaptchaImagePopup;
// =============================================
// POPUP FORM — Submit
// =============================================
const $7bb113885e6342e7$var$FormSubmitPopup = async (e)=>{
    e.preventDefault();
    const submitBtn = document.getElementById("form-buttonPopup");
    if (submitBtn.disabled) return;
    // Honeypot check
    const honeypot = document.getElementById("honeypotPopup");
    if (honeypot && honeypot.value !== "") return;
    const name = document.getElementById("fullNamePopup")?.value.trim();
    const email = document.getElementById("emailPopup")?.value.trim();
    const phoneRaw = document.getElementById("Phone_numberPopup")?.value.trim();
    const message = document.getElementById("projectPopup")?.value.trim() || "";
    const captchaInput = document.getElementById("captchaInputPopup")?.value.trim();
    const countrySelectPopup = document.getElementById("countryCodePopup");
    const countryCode = countrySelectPopup?.value || "";
    // Validations — reuse original helpers, just swap focusField target IDs
    if (!name || name.length < 3) {
        alert("Please enter a valid full name (at least 3 characters).");
        focusField("fullNamePopup");
        return;
    }
    if (!email) {
        alert("Please enter your email address.");
        focusField("emailPopup");
        return;
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!emailPattern.test(email)) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        focusField("emailPopup");
        return;
    }
    const localPart = email.split("@")[0];
    if ((localPart.match(/\./g) || []).length > 2) {
        alert("Please enter a valid email address (e.g. name@example.com).");
        focusField("emailPopup");
        return;
    }
    const trimmedMessage = message?.trim();
    if (trimmedMessage && trimmedMessage.length < 10) {
        alert("Please enter a valid message (at least 10 characters).");
        focusField("projectPopup");
        return;
    }
    const cleaned = (phoneRaw || "").replace(/\D/g, "");
    if (cleaned.length < 7 || cleaned.length > 15) {
        alert("Please enter a valid phone number (7 to 15 digits) with country code.");
        focusField("Phone_numberPopup");
        return;
    }
    if (!captchaInput) {
        alert("Please enter the CAPTCHA code shown in the image.");
        focusField("captchaInputPopup");
        return;
    }
    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("phone", cleaned);
    formData.append("country_code", countryCode);
    formData.append("description", message);
    formData.append("captcha_0", $7bb113885e6342e7$var$savedCaptchaCodePopup);
    formData.append("captcha_1", captchaInput);
    formData.append("source", "contact-us");
    formData.append("user_agent", navigator.userAgent);
    try {
        const response = await fetch(`${"https://quokkalabs.com"}/blog/api/contact-us`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) throw new Error("Form failed");
        const result = await response.json();
        if (result?.data?.name) localStorage.setItem("contact_name", result.data.name);
        if (result?.data?.email) localStorage.setItem("contact_email", result.data.email);
        window.location.href = "/thankyou";
    } catch (error) {
        console.error(error);
        submitBtn.disabled = false;
        submitBtn.textContent = "Send Inquiry";
        $7bb113885e6342e7$var$createCaptchaImagePopup();
    }
};
window.FormSubmitPopup = $7bb113885e6342e7$var$FormSubmitPopup;
function $7bb113885e6342e7$export$dde0c64ce481f9c0(options = {}) {
    const delay = options.delay || 15000;
    // Inject the HTML first
    $7bb113885e6342e7$var$injectPopupHTML();
    $7bb113885e6342e7$var$initCountryCodeDropdown();
    $7bb113885e6342e7$var$createCaptchaImagePopup();
    $7bb113885e6342e7$var$loadCountryCodesPopup();
    // Setup and show popup after delay
    setTimeout(()=>$7bb113885e6342e7$var$setupPopup(), delay);
}
function $7bb113885e6342e7$export$b2fc6847e1452de() {
    $7bb113885e6342e7$var$injectPopupHTML();
    $7bb113885e6342e7$var$initCountryCodeDropdown();
    $7bb113885e6342e7$var$createCaptchaImagePopup();
    $7bb113885e6342e7$var$loadCountryCodesPopup();
    $7bb113885e6342e7$var$setupPopup();
}
window.addEventListener("load", ()=>$7bb113885e6342e7$export$dde0c64ce481f9c0());


//# sourceMappingURL=adapt.1f520ff9.js.map
